import { FC, useEffect } from 'react';
import Typography from 'src/common/components/Typography';
import Button from 'src/common/components/ButtonDS22';
import { PATHS } from 'src/common/constants';
import { useUserContext } from 'src/common/providers/UserProvider';
import { useTranslation } from 'next-i18next';
import { trackBroadcastEvent, type ContextNames } from 'src/inquiry/utils/trackBroadcastEvent';
import styles from './InquiryBroadcastErrors.module.scss';

export type InquiryBroadcastError = 'error-wrong-user' | 'error-broadcast-empty';

type Props = {
  error: InquiryBroadcastError;
  inquiryId: string;
  context: ContextNames;
};

const InquiryBroadcastErrors: FC<Props> = ({
  error,
  inquiryId,
  context,
}) => {
  const { logout } = useUserContext();
  const [t] = useTranslation('inquiry-broadcast');

  useEffect(() => {
    trackBroadcastEvent({
      event: 'show',
      component_type: 'page',
      object: error,
      context,
      object_properties: {
        inquiry_id: inquiryId,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.root}>
      {error === 'error-wrong-user' && (
        <>
          <Typography size="heading-5" weight="semibold" type="h1">
            {t('error-wrong-user-title')}
          </Typography>
          <Typography size="body-xl" type="p">
            {t('error-wrong-user-description')}
          </Typography>
          <Button onClick={logout} fitWidth>{t('error-wrong-user-cta')}</Button>
        </>
      )}
      {error === 'error-broadcast-empty' && (
        <>
          <Typography size="heading-5" weight="semibold" type="h1">
            {t('error-broadcast-empty-title')}
          </Typography>
          <Typography size="body-xl" type="p">
            {t('error-broadcast-empty-description')}
          </Typography>
          <Button type="link" href={PATHS.SEARCH} fitWidth>{t('error-broadcast-empty-cta')}</Button>
        </>
      )}
    </div>
  );
};

export default InquiryBroadcastErrors;
